//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/TaggedObject.js";
import "../CAM/CAM.ExpressionDouble.js";
import "../CAM/CAM.ExpressionString.js";
let d=[[[0,"BooleanValue",1,0],[0,"Csys",1,"NXObject",0],[0,"DoubleValue",1,0],[1,"ExpressionDouble",0,"CAM.ExpressionDouble",0],[1,"ExpressionString",0,"CAM.ExpressionString",0],[0,"IntegerValue",1,0],[0,"NameOfParameter",0,0],[0,"OptionText",1,0],[0,"OptionValue",1,1],[0,"ParameterActive",1,0],[0,"ParameterOptional",0,0],[0,"Point",1,"Point",0],[0,"StringText",1,0],[0,"StringValue",1,1],[0,"TypeOfParameter",0,0],[0,"Vector",1,"NXObject",0]],[],[]];
SPLM.CAM.UdeParameter = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.UdeParameter";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.UdeParameter.ParameterTypes = Object.freeze({
    "Integer" : "Integer", "Double" : "Double", "Boolean" : "Boolean", "String" : "String", "Option" : "Option", "Point" : "Point", "Vector" : "Vector", "Legend" : "Legend", "Group" : "Group", "Csys" : "Csys"});

export default SPLM;